<template>
  <el-select style="width: 100%" v-bind="$props" @input="handleInput"
             @change="handleChange"
             filterable
             allow-create
             default-first-option>
    <el-option v-for="opt in options" :key="opt" :value="opt" :label="opt"></el-option>
  </el-select>
</template>

<script>
import {dictTypeList} from "api/remote";

export default {
  name: "DictTypeSelect",
  props: {
    value: {},
    multiple: Boolean,
    filterable: Boolean,
    clearable: Boolean,
    placeholder: String,
  },
  data() {
    return {
      options: []
    }
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val);
    },
    handleChange(val) {
      this.$emit('change', val);
    }
  },
  created() {
    dictTypeList().then(res => {
      this.options = res.data;
    })
  },
}
</script>

<style scoped>

</style>
